var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center justify-center fill-height",class:_vm.bgColor},[_c('v-progress-circular',{attrs:{"color":_vm.color,"size":43,"width":3,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }